import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../components/header';
import Hero from '../components/hero';
import Products from '../components/products';
import Quality from '../components/quality';
import Contact from '../components/contact';
import Footer from '../components/footer';
import About from "../components/about";
import SociosComerciales from "../components/sociosComerciales";
import CareersSection from "../components/joinTeam";
import Video from "../components/video";
import Timeline from "../components/linetime";
import Chatbox from "../components/chatbox";
// import NewsComponent from "../components/news";
import Introducción from "../components/introducción";
import RecetarioGourmet from "../components/recetario";
import MaquiladorasDashboard from "../components/maquiladoras";
// import EventosPortal from "../components/eventos";
import Quejas from "../components/quejas";
import Marcas from "../components/marcas";


const navigationItems = [
  { id: 'inicio', name: 'Inicio' },
  { id: 'marcas', name: 'Nuestras Marcas',
    subItems: [
      { id: 'recetario', name: 'Recetario' }
    ]
  },
  { id: 'productos', name: 'Nuestros Productos' },
  { id: 'clientes', name: 'Socios Comerciales' },
  { id: 'maquiladoras', name: 'Maquilas' },
  // { id: 'noticias', name: 'Noticias'},
  // { id: 'eventos', name: 'Eventos'},
  { id: 'trabajo', name: 'Únete al equipo' },
  { id: 'contacto', name: 'Contacto' },
  { id: 'politica', name: 'Políticas' },
  { id: 'quejas', name: 'Quejas y Sugerencias' }
];

const Home = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [currentView, setCurrentView] = useState('inicio');

  // Determinar la vista actual basada en la ruta
  useEffect(() => {
    const path = location.pathname;
    let view = 'inicio';
    
    if (path === '/' || path === '/inicio') {
      view = 'inicio';
    } else if (path === '/nosotros') {
      view = 'nosotros';
    } else if (path === '/marcas') {
      view = 'marcas';
    } else if (path === '/productos') {
      view = 'productos';
    // } else if (path === '/noticias') {
    //   view = 'noticias';
    } else if (path === '/clientes') {
      view = 'clientes';
    } else if (path === '/trabajo') {
      view = 'trabajo';
    } else if (path === '/contacto') {
      view = 'contacto';
    } else if (path === '/politica') {
      view = 'politica';
    } else if (path === '/recetario') {
        view = 'recetario';
    } else if (path === '/maquiladoras') {
      view = 'maquiladoras';
    // } else if (path === '/eventos') {
    //   view = 'eventos';
    } else if (path === '/quejas') {
      view = 'quejas';
    }
    
    setCurrentView(view);
  }, [location.pathname]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const scrollToSection = (id) => {
    // Navegar a la nueva ruta
    if (id === 'inicio') {
      navigate('/');
    } else {
      navigate(`/${id}`);
    }
  };

  const renderContent = () => {
    switch(currentView) {      case 'inicio':
        return (
          <>
            <Hero currentView={currentView} setCurrentView={setCurrentView} />
            <Video />
            <Introducción />
            <Quality />

          </>
        );
      case 'marcas':
        return <Marcas />;
      case 'productos':
        return <Products />;
      case 'contacto':
        return <Contact />;
        case 'clientes':  
        return <SociosComerciales />;
        case 'trabajo':
          return <CareersSection />;
          // case 'noticias':
          //   return <NewsComponent />;
            case 'politica':
              return ( 
              <>
              <About />
              <Timeline />
              </> 
              )
              case 'recetario':
                return <RecetarioGourmet />;
                case 'maquiladoras':
                  return <MaquiladorasDashboard />;
                  // case 'eventos':
                  //   return <EventosPortal />;
                  case 'quejas':
                    return <Quejas />;
      default:
    }
  };  return (
    <div className="min-h-screen flex flex-col">
      <Header 
        navigationItems={navigationItems}
        activeSection={currentView}
        scrollToSection={scrollToSection}
      />
      <main className="pt-20 flex-grow">
        {renderContent()}
      </main>
      <Footer currentView={currentView} setCurrentView={setCurrentView} />
      <Chatbox />
    </div>
  );
};

export default Home;